"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SkipToMainContent = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _localization = require("../shared/localization");

var SkipToMainContent = function SkipToMainContent(_ref) {
  var _ref$skipTo = _ref.skipTo,
      skipTo = _ref$skipTo === void 0 ? 'main:first-of-type' : _ref$skipTo,
      label = _ref.label;
  var buttonClass = (0, _react.memoizeFunction)(function () {
    return (0, _react.mergeStyles)({
      position: 'absolute',
      left: '-1000px',
      ':focus': {
        position: 'static'
      }
    });
  })();

  var _useLocalization = (0, _localization.useLocalization)('Language'),
      _useLocalization2 = (0, _slicedToArray2.default)(_useLocalization, 1),
      t = _useLocalization2[0];

  var labelText = label || t('skipToMainContent');

  var onClickHandler = function onClickHandler() {
    var container = document.querySelector(skipTo);

    if (container) {
      var previousTabIndex = container.getAttribute('tabindex');
      container.tabIndex = -1;
      container.focus();
      window.setTimeout(function () {
        if (previousTabIndex) {
          container.tabIndex = Number(previousTabIndex);
        } else {
          container.removeAttribute('tabindex');
        }
      }, 1000);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    className: buttonClass,
    onClick: onClickHandler,
    children: labelText
  });
};

exports.SkipToMainContent = SkipToMainContent;